import { ElectionAttribute } from '~/definitions/election';

export const getAttributeValue = (key: string, attributes: ElectionAttribute[]): string => {
    const attribute = attributes?.find((attr) => attr.number === key);
    return attribute?.value || '';
};
